export default {
  zh: {
    home: "主页",
    addTheCompany: "添加公司/基金",
    orderNumber: "申请号码",
    company: "公司名称",
    tradeDate: "创建日期",
    country: "国家",
    combo: "套餐描述",
    proposer: "申请人",
    companyName: "公司/基金名",
    companyName01: "公司名(第1选项)",
    companyName02: "公司名(第2选项)",
    companyName03: "公司名(第3选项)",
    applicationStatus: "申请状态",
    viewDetails: "查看",
    fillInfor: "填写资料",
    anewInfor: "重传资料",
    payment: "待支付",
    orderList: "订单列表",
    appraise: "去评价",
    delete: "删除",
    noData: "您当前还没有注册过任何公司，赶紧去注册吧",
    toCreation: "立即注册公司",
    supplementalNo: "补款号码",
    supplementalCountry: "国家",
    description: "描述",
    supplementalStatus: "补款状态",
    passed: "通过",
    forfeited: "废弃",
    linkedTransactionNo: "关联的申请号码",
    billingParty: "支付方",
    serviceCharge: "服务费",
    thirdPartyFee: "第三方费用",
    otherFee: "其他费用",
  },
  en: {
    home: "Home",
    addTheCompany: "Add a company/fund",
    orderNumber: "Transaction No.",
    company: "Company",
    tradeDate: "Create Date",
    country: "Country of Company/Fund",
    combo: "Service Description",
    proposer: "Applicant",
    companyName: "Company/Fund name",
    companyName01: "Company name (Option 1)",
    companyName02: "Company name (Option 2)",
    companyName03: "Company name (Option 3)",
    applicationStatus: "Status",
    viewDetails: "View",
    fillInfor: "Edit",
    anewInfor: "Re-upload",
    payment: "Unpaid",
    orderList: "Order List",
    appraise: "Appraise",
    delete: "Delete",
    noData: "You haven't registered any company.",
    toCreation: "Register the company immediately",
    supplementalNo: "Supplemental No.",
    supplementalCountry: "Country",
    description: "Description",
    supplementalStatus: "Status",
    passed: "Passed",
    forfeited: "Forfeited",
    linkedTransactionNo: "Linked Transaction No.",
    billingParty: "Billing Party",
    serviceCharge: "Service Charge",
    thirdPartyFee: "Third Party Fee",
    otherFee: "Other Fee",
  },
};
